import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Api from './Config';

export default class MyNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = { app_code: '', hl7visible: false, reviewhl7: false };
  }

  componentDidMount() {
    this.setState({
      username: localStorage.getItem('username'),
      app_code: localStorage.getItem('app_code'),
      ROLE: localStorage.getItem('ROLE'),
      cluster_id: localStorage.getItem('cluster_id'),
    });
    Api.hashl7logmenu()
      .then((data) => {
        Api.IS_HL7_VISIBLE = data.menu;
        this.setState({ hl7visible: data.menu, reviewhl7: data.reviewhl7 });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  changeLink(link) {
    // alert(link);
    this.props.history.push(`/${link}`);
  }

  doLogout() {
    localStorage.setItem('UID', '');
    localStorage.setItem('app_code', '');
    localStorage.setItem('username', '');
    localStorage.setItem('cluster_id', '');
    Api.logout().catch((e) => {});
    this.props.history.push('/');
  }

  showOldReviewer(app_code, cluster_id) {
    return app_code.includes('njrmg') || cluster_id == 2;
  }

  render_office_menu() {
    return (
      <div>
        <nav className="navbar navbar-default">
          <div>
            <a
              onClick={() => {
                this.changeLink('adminDoctor');
              }}
              className="navbar-brand"
              style={{ cursor: 'pointer' }}
            >
              Provider Office Portal
            </a>

            <ul className="nav navbar-nav navbar-right">
              <li>
                <a>Logged in as :{this.state.username}</a>
              </li>
              <li>
                <a>
                  AppCode:
                  {this.state.app_code}
                </a>
              </li>

              <li
                style={{ cursor: 'pointer', marginRight: 20 }}
                onClick={() => {
                  this.doLogout();
                }}
              >
                <a>Logout</a>
              </li>
            </ul>
          </div>
          <div style={{ marginTop: 40 }} className="visible-lg visible-md hidden-xs" />
          <div className="container-fluid">
            <div className="navbar-header" className="navbar-header-no-left">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navbar"
                aria-expanded="false"
                aria-controls="navbar"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
            </div>
            <div id="navbar" className="navbar-collapse collapse">
              <ul className="nav navbar-nav">
                <li
                  className={
                    this.props.location.pathname == '/patients' || this.props.location.pathname == '/JourneyDetail'
                      ? 'active'
                      : ''
                  }
                >
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.changeLink('patients');
                    }}
                  >
                    Patients
                  </a>
                </li>
                <li className={this.props.location.pathname == '/dashboard' ? 'active' : ''}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.changeLink('dashboard');
                    }}
                  >
                    Dashboard
                  </a>
                </li>
                {false && (
                  <li className={this.props.location.pathname == '/JourneyMaster' ? 'active' : ''}>
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        this.changeLink('JourneyMaster');
                      }}
                    >
                      Journeys
                    </a>
                  </li>
                )}
                <li className={this.props.location.pathname == '/alerts' ? 'active' : ''}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.changeLink('alerts');
                    }}
                  >
                    No-reply Alerts
                  </a>
                </li>

                <li className={this.props.location.pathname == '/archivedPatients' ? 'active' : ''}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.changeLink('archivedPatients');
                    }}
                  >
                    Archive
                  </a>
                </li>

                {(Api.IS_HL7_VISIBLE || this.state.hl7visible) && (
                  <li className={this.props.location.pathname == '/hl7logs' ? 'active' : ''}>
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        this.changeLink('hl7logs');
                      }}
                    >
                      Picasso Logs
                    </a>
                  </li>
                )}

                {this.state.reviewhl7 == true && this.showOldReviewer(this.state.app_code, this.state.cluster_id) && (
                  <li className={this.props.location.pathname == '/hl7Review' ? 'active' : ''}>
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        this.changeLink('hl7Review');
                      }}
                    >
                      Reviewer
                    </a>
                  </li>
                )}

                <li className={this.props.location.pathname == '/newhl7Review' ? 'active' : ''}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.changeLink('newhl7Review');
                    }}
                  >
                    Watchtower
                  </a>
                </li>

                {false && (
                  <li className={this.props.location.pathname == '/pendingusers' ? 'active' : ''}>
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        this.changeLink('pendingusers');
                      }}
                    >
                      Pending List
                    </a>
                  </li>
                )}

                {(this.state.ROLE == Api.ROLE_SUPER ||
                  this.state.ROLE == Api.ROLE_MANAGER ||
                  this.state.ROLE == Api.ROLE_OFFICE_ADMIN) && (
                  <li className={this.props.location.pathname == '/actreport' ? 'active' : ''}>
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        this.changeLink('actreport');
                      }}
                    >
                      Reporting
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }

  render_review_menu() {
    return (
      <div>
        <nav className="navbar navbar-default">
          <div>
            <a
              onClick={() => {
                this.changeLink('adminDoctor');
              }}
              className="navbar-brand"
              style={{ cursor: 'pointer' }}
            >
              Provider Office Portal
            </a>

            <ul className="nav navbar-nav navbar-right">
              <li>
                <a>Logged in as :{this.state.username}</a>
              </li>
              <li>
                <a>
                  AppCode:
                  {this.state.app_code}
                </a>
              </li>

              <li
                style={{ cursor: 'pointer', marginRight: 20 }}
                onClick={() => {
                  this.doLogout();
                }}
              >
                <a>Logout</a>
              </li>
            </ul>
          </div>
          <div style={{ marginTop: 40 }} className="visible-lg visible-md hidden-xs" />
          <div className="container-fluid">
            <div className="navbar-header" className="navbar-header-no-left">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navbar"
                aria-expanded="false"
                aria-controls="navbar"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
            </div>
            <div id="navbar" className="navbar-collapse collapse">
              <ul className="nav navbar-nav">
                <li className={this.props.location.pathname == '/hl7Review' ? 'active' : ''}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      this.changeLink('hl7Review');
                    }}
                  >
                    Reviewer
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }

  render() {
    const ROLE = localStorage.getItem('ROLE');
    if (ROLE != 2) {
      //   return this.render_office_menu();
    }
    //  return this.render_review_menu();
    return this.render_office_menu();
  }
}
